<template>
  <div class="size-chart-menu">
    <p v-if="title" class="o-caption mb-1" v-text="title" />
    <div>
      <button
        v-for="zone in sizechartZonesKeys"
        :key="zone"
        :class="[
          'size-chart-menu-button o-body font-semibold mr-2 rounded py-1 px-5 border-1 border-women-textShade focus:outline-none',
          `${zone}-button`,
          { 'text-white bg-women-text size-chart-menu-button-active': sizechartZone === zone }
        ]"
        @click="$emit('click', { zone })"
      >
        {{ $t(`Sizechart.Menu.${zone}`) }}
      </button>
    </div>
  </div>
</template>

<script>
import { SizechartZones } from '@/enums/sizechart'

export default {
  name: 'SizeChartMenu',
  props: {
    title: {
      type: String,
      default: ''
    },
    sizechartZone: {
      type: String,
      default: SizechartZones.eu
    }
  },
  computed: {
    sizechartZonesKeys () {
      return Object.values(SizechartZones)
    }
  }
}
</script>

<style lang="postcss" scoped>

</style>
